import { FinanceApplicationReportUIFilters } from '@/shared/ui-models/finance-application-report.ui-model';

export const initialFinanceApplicationsFiltersValues: FinanceApplicationReportUIFilters = {
  startDate: null,
  endDate: null,
  status: [],
  agent: [],
  financialMerchantId: { id: '', label: '' },
  source: []
};

export const validateFinanceApplicationReportFiltersForm = (
  fieldValues: FinanceApplicationReportUIFilters,
  errors: { [key: string]: string },
  setErrors: (error: any) => void,
  t: (key: string) => string
) => {
  const temp: { [key: string]: unknown } = { ...errors };

  if ('startDate' in fieldValues)
    temp.startDate = fieldValues.startDate ? '' : t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.START_DATE_REQUIRED');
  if ('endDate' in fieldValues) temp.endDate = fieldValues.endDate ? '' : t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.END_DATE_REQUIRED');

  // endDate should be greater than startDate
  if (fieldValues.startDate && fieldValues.endDate) {
    if (fieldValues.startDate > fieldValues.endDate) {
      temp.endDate = t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.END_DATE_GREATER_THAN_START');
    }
  }

  setErrors({
    ...temp
  });

  const isValidForm = Object.values(temp).every((x) => x === '');
  if (isValidForm) {
    return { valid: true, error: '' };
  } else {
    return {
      valid: false,
      error: t('REPORTS_MODULE.FINANCE_APPLICATIONS_REPORT.VALIDATION.FILL_MANDATORY_DATA')
    };
  }
};
